import React from 'react';

function Team() {
    return (
        <section className="relative overflow-hidden">
            <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
                <div className="py-12 md:py-16 border-t border-gray-800 border-opacity-60">
                    {/* Section header */}
                    <div className="max-w-4xl mx-auto text-center pb-10 md:pb-12">
                        <p className="text-xs font-semibold tracking-[0.25em] text-gray-400 mb-3">
                            LEADERSHIP TEAM
                        </p>
                        <h2 className="h3 mb-4 text-gray-100">
                            Experience from insurance, telematics and cloud.
                        </h2>
                        <div className="mx-auto h-1 w-20 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />
                    </div>

                    {/* Team members */}
                    <div
                        className="grid gap-8 sm:grid-cols-2 lg:gap-10"
                        data-aos-id-team
                    >
                        {/* 1st member */}
                        <div
                            className="group flex h-full flex-col rounded-3xl bg-gray-900 bg-opacity-80 p-6 sm:p-7 shadow-xl border border-gray-800 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl"
                            data-aos="fade-up"
                            data-aos-anchor="[data-aos-id-team]"
                        >
                            <div className="flex items-center gap-4 md:gap-5">
                                <div className="flex-shrink-0">
                                    <div className="relative">
                                        <div
                                            className="absolute inset-0 rounded-full opacity-60"
                                            style={{
                                                background:
                                                    'conic-gradient(from 180deg, rgba(59,130,246,0.6), rgba(236,72,153,0.6), rgba(59,130,246,0.6))',
                                                filter: 'blur(8px)',
                                            }}
                                            aria-hidden="true"
                                        />
                                        <img
                                            className="relative h-24 w-24 rounded-full object-cover ring-2 ring-gray-900"
                                            src={require('../images/TeamProfiles/Kerry.jpg').default}
                                            width="140"
                                            height="140"
                                            alt="Kerry Michael"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col justify-center">
                                    <h4 className="text-xl font-semibold mb-1 text-left text-gray-100">
                                        Kerry Michael MBE
                                    </h4>
                                    <div className="text-sm font-medium text-left text-gray-300">
                                        Chairman
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 text-sm md:text-[15px] leading-relaxed text-gray-200 text-left">
                                Kerry brings decades of leadership experience in scaling technology-enabled insurance businesses. Before founding AGM Technologies, he built The Regency Group into the UK’s largest extended-warranty insurer and later joined the RAC as Commercial Director, where he played a key role in the organisation’s transformation during the 2010s.
                                It was here that Kerry recognised the industry’s need for smarter, data-driven solutions that could improve underwriting accuracy and customer experience. This insight led to the creation of AGMT, a company focused on developing advanced sensing, analytics and software solutions for enterprise partners.
                            </div>
                        </div>

                        {/* 2nd member */}
                        <div
                            className="group flex h-full flex-col rounded-3xl bg-gray-900 bg-opacity-80 p-6 sm:p-7 shadow-xl border border-gray-800 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl"
                            data-aos="fade-up"
                            data-aos-delay="150"
                            data-aos-anchor="[data-aos-id-team]"
                        >
                            <div className="flex items-center gap-4 md:gap-5">
                                <div className="flex-shrink-0">
                                    <div className="relative">
                                        <div
                                            className="absolute inset-0 rounded-full opacity-60"
                                            style={{
                                                background:
                                                    'conic-gradient(from 180deg, rgba(59,130,246,0.6), rgba(236,72,153,0.6), rgba(59,130,246,0.6))',
                                                filter: 'blur(8px)',
                                            }}
                                            aria-hidden="true"
                                        />
                                        <img
                                            className="relative h-24 w-24 rounded-full object-cover ring-2 ring-gray-900"
                                            src={require('../images/TeamProfiles/George.jpg').default}
                                            width="140"
                                            height="140"
                                            alt="George Michael"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col justify-center">
                                    <h4 className="text-xl font-semibold mb-1 text-left text-gray-100">
                                        George Michael
                                    </h4>
                                    <div className="text-sm font-medium text-left text-gray-300">
                                        Chief Executive Officer
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 text-sm md:text-[15px] leading-relaxed text-gray-200 text-left">
                                George leads AGMT’s commercial and operational strategy, ensuring the company delivers high-quality technology solutions while maintaining strong financial performance. With deep experience across sensing hardware, analytics and mobility technologies, George acts as the bridge between customer needs and technical execution. He has restructured AGMT’s supply chain and product operations to create a scalable foundation for international growth. His focus is on building a business that consistently turns technical innovation into real-world solutions for insurers, fleets and mobility partners.
                            </div>
                        </div>

                        {/* 3rd member */}
                        <div
                            className="group flex h-full flex-col rounded-3xl bg-gray-900 bg-opacity-80 p-6 sm:p-7 shadow-xl border border-gray-800 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-anchor="[data-aos-id-team]"
                        >
                            <div className="flex items-center gap-4 md:gap-5">
                                <div className="flex-shrink-0">
                                    <div className="relative">
                                        <div
                                            className="absolute inset-0 rounded-full opacity-60"
                                            style={{
                                                background:
                                                    'conic-gradient(from 180deg, rgba(59,130,246,0.6), rgba(236,72,153,0.6), rgba(59,130,246,0.6))',
                                                filter: 'blur(8px)',
                                            }}
                                            aria-hidden="true"
                                        />
                                        <img
                                            className="relative h-24 w-24 rounded-full object-cover ring-2 ring-gray-900"
                                            src={require('../images/TeamProfiles/Joe.jpg').default}
                                            width="140"
                                            height="140"
                                            alt="Joe Walford"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col justify-center">
                                    <h4 className="text-xl font-semibold mb-1 text-left text-gray-100">
                                        Joe Walford
                                    </h4>
                                    <div className="text-sm font-medium text-left text-gray-300">
                                        Chief Software Officer
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 text-sm md:text-[15px] leading-relaxed text-gray-200 text-left">
                                Joe is responsible for AGMT’s software architecture, cloud strategy and the technical direction of our sensing and data platforms. With a strong engineering background and hands-on expertise in distributed systems, he oversees everything from backend microservices and high-availability APIs to the algorithms, data pipelines and testing frameworks that power AGMT’s solutions. His work spans product development, technical strategy and system reliability, ensuring that AGMT’s platforms scale smoothly and deliver accurate, real-time intelligence in demanding operational environments.
                            </div>
                        </div>

                        {/* 5th member */}
                        <div
                            className="group flex h-full flex-col rounded-3xl bg-gray-900 bg-opacity-80 p-6 sm:p-7 shadow-xl border border-gray-800 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl"
                            data-aos="fade-up"
                            data-aos-delay="250"
                            data-aos-anchor="[data-aos-id-team]"
                        >
                            <div className="flex items-center gap-4 md:gap-5">
                                <div className="flex-shrink-0">
                                    <div className="relative">
                                        <div
                                            className="absolute inset-0 rounded-full opacity-60"
                                            style={{
                                                background:
                                                    'conic-gradient(from 180deg, rgba(59,130,246,0.6), rgba(236,72,153,0.6), rgba(59,130,246,0.6))',
                                                filter: 'blur(8px)',
                                            }}
                                            aria-hidden="true"
                                        />
                                        <img
                                            className="relative h-24 w-24 rounded-full object-cover ring-2 ring-gray-900"
                                            src={require('../images/TeamProfiles/steve.png').default}
                                            width="140"
                                            height="140"
                                            alt="Steve Cowper"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col justify-center">
                                    <h4 className="text-xl font-semibold mb-1 text-left text-gray-100">
                                        Steve Cowper
                                    </h4>
                                    <div className="text-sm font-medium text-left text-gray-300">
                                        Chief Technology Officer
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 text-sm md:text-[15px] leading-relaxed text-gray-200 text-left">
                                Steve brings more than 20 years of experience in intelligent sensing, embedded hardware, connected devices and applied data analytics. He has deep expertise in sensor design, crash detection techniques, driver risk measurement and the deployment of low-power edge intelligence at scale across insurance and mobility environments.
                                His career spans senior technical and advisory roles across IoT, EV platforms, asset tracking and wireless systems, including work with global technology organisations and fast-growing startups. Steve has been instrumental in the development of patented sensing and crash-detection technologies, with independently validated accuracy in real-world operating conditions.
                                At AGMT, Steve focuses on designing sensing hardware that performs reliably in real-world, large-scale deployments.
                            </div>
                        </div>

                        {/* 4th member */}
                        <div
                            className="group flex h-full flex-col rounded-3xl bg-gray-900 bg-opacity-80 p-6 sm:p-7 shadow-xl border border-gray-800 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl"
                            data-aos="fade-up"
                            data-aos-delay="250"
                            data-aos-anchor="[data-aos-id-team]"
                        >
                            <div className="flex items-center gap-4 md:gap-5">
                                <div className="flex-shrink-0">
                                    <div className="relative">
                                        <div
                                            className="absolute inset-0 rounded-full opacity-60"
                                            style={{
                                                background:
                                                    'conic-gradient(from 180deg, rgba(59,130,246,0.6), rgba(236,72,153,0.6), rgba(59,130,246,0.6))',
                                                filter: 'blur(8px)',
                                            }}
                                            aria-hidden="true"
                                        />
                                        <img
                                            className="relative h-24 w-24 rounded-full object-cover ring-2 ring-gray-900"
                                            src={require('../images/TeamProfiles/mario.jpeg').default}
                                            width="140"
                                            height="140"
                                            alt="Mario Dolcezza"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col justify-center">
                                    <h4 className="text-xl font-semibold mb-1 text-left text-gray-100">
                                        Mario Dolcezza
                                    </h4>
                                    <div className="text-sm font-medium text-left text-gray-300">
                                        Chief Revenue Officer
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 text-sm md:text-[15px] leading-relaxed text-gray-200 text-left">
                                Mario leads AGMT’s commercial strategy and partnerships, ensuring our technology delivers clear, measurable value to insurers, fleets and mobility providers. With a career spanning insurance innovation, private equity and large-scale operational transformation, he brings a deep understanding of how technology can reshape traditional industries.
                                Before joining AGMT, Mario played a pivotal role in modernising core services at the RAC and was instrumental in introducing telematics into the organisation following its private-equity acquisition in the 2010s. His experience integrating emerging technologies into established platforms enables him to translate complex market needs into commercially successful solutions.
                            </div>
                        </div>

                        {/* 6th member */} 
                        <div
                            className="group flex h-full flex-col rounded-3xl bg-gray-900 bg-opacity-80 p-6 sm:p-7 shadow-xl border border-gray-800 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl"
                            data-aos="fade-up"
                            data-aos-delay="250"
                            data-aos-anchor="[data-aos-id-team]"
                        >
                            <div className="flex items-center gap-4 md:gap-5">
                                <div className="flex-shrink-0">
                                    <div className="relative">
                                        <div
                                            className="absolute inset-0 rounded-full opacity-60"
                                            style={{
                                                background:
                                                    'conic-gradient(from 180deg, rgba(59,130,246,0.6), rgba(236,72,153,0.6), rgba(59,130,246,0.6))',
                                                filter: 'blur(8px)',
                                            }}
                                            aria-hidden="true"
                                        />
                                        <img
                                            className="relative h-24 w-24 rounded-full object-cover ring-2 ring-gray-900"
                                            src={require('../images/TeamProfiles/Wayne.jpg').default}
                                            width="140"
                                            height="140"
                                            alt="Wayne Gilbert"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col justify-center">
                                    <h4 className="text-xl font-semibold mb-1 text-left text-gray-100">
                                        Wayne Gilbert
                                    </h4>
                                    <div className="text-sm font-medium text-left text-gray-300">
                                        Former Co-Founder
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 text-sm md:text-[15px] leading-relaxed text-gray-200 text-left">
                                Wayne’s expertise and leadership were foundational to the development of AGMT’s technology portfolio. A former Director at Celestica and TES Electronic Solutions, Wayne worked at the forefront of emerging wireless, sensing and electronic systems for more than three decades. His experience as CTO at Masternaut and Risk Technologies, where he helped shape industry-leading IP and telematics platforms, proved invaluable to AGMT’s early innovation.
                                Wayne was instrumental in securing AGMT’s core patents in both Europe and the United States and in establishing the engineering principles that underpin our solutions today. His influence continues to guide our work, and his impact on the industry and on everyone who had the privilege to work with him, remains profound.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Team;
